package org.example.zone360.pages.coachDetails.sessionAllDetails

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.CSSLengthOrPercentageNumericValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.alignItems
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.bottom
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.maxHeight
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.compose.ui.modifiers.minWidth
import com.varabyte.kobweb.compose.ui.modifiers.onBlur
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.onFocusIn
import com.varabyte.kobweb.compose.ui.modifiers.onKeyUp
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.coroutines.launch
import org.example.zone360.componentss.FieldTitleTextNormalSimple
import org.example.zone360.models.GetClubCoachesData
import org.example.zone360.theme.SitePalette
import org.example.zone360.utils.AppGlobal
import org.example.zone360.utils.Constants
import org.example.zone360.utils.Res
import org.example.zone360.utils.noBorder
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Input
import org.w3c.dom.Element
import org.w3c.dom.HTMLInputElement
import org.w3c.dom.events.EventListener
import org.example.zone360.utils.tagUser

@Composable
fun CoachTokenSearch(
    sitePalette: SitePalette,
    breakpoint: Breakpoint,
    minWidth: CSSLengthOrPercentageNumericValue = 350.px,
    coaches: List<GetClubCoachesData>,
    onCoachSelected: (sentenceId: String, GetClubCoachesData) -> Unit,
    onCoachRemoved: (sentenceId: String, GetClubCoachesData) -> Unit,
    selectedCoachesMap: Map<String, List<GetClubCoachesData>>? = null,
    selectedCoachesList: MutableList<GetClubCoachesData>? = null,
    sentenceId: String,
    sessionId: String = "",
    currentCoachId: String? = null,
    searchInputId: String = "coach_search_$sentenceId",
    apiHit: Boolean = true,
    backgroundColor: Color? = null,
    tokenBackgroundColor: Color? = null,
    openUpward: Boolean = false
) {
    var showDropdown by remember { mutableStateOf(false) }
    var filteredCoaches by remember { mutableStateOf<List<GetClubCoachesData>>(emptyList()) }
    val scope = rememberCoroutineScope()
    var isFocused by remember { mutableStateOf(false) }

    val currentSelectedCoaches = selectedCoachesMap?.get(sentenceId).orEmpty() + selectedCoachesList.orEmpty()


    DisposableEffect(showDropdown) {
        val listener = EventListener { event ->
            if (showDropdown) {
                val target = event.target as? Element
                if (target != null && target.closest(".services-dropdown, .dropdown-trigger") == null) {
                    showDropdown = false
                }
            }
        }
        window.addEventListener("click", listener)
        onDispose {
            window.removeEventListener("click", listener)
        }
    }

    Box(modifier = Modifier.fillMaxWidth().position(Position.Relative)) {
        Row(
            modifier = Modifier
                .minWidth(if (breakpoint > Breakpoint.MD) minWidth else 100.percent)
                .minHeight(48.px)
                .backgroundColor(backgroundColor ?: sitePalette.lightGrey.rgb)
                .borderRadius(6.px)
                .border(1.px, style = LineStyle.Solid,
                    color = if (isFocused) Colors.Green else sitePalette.textFieldBorderColor.rgb)
                .padding(leftRight = 8.px)
                .overflow(overflowY = Overflow.Auto, overflowX = Overflow.Hidden)
                .flexWrap(FlexWrap.Wrap)
                .gap(7.px)
                .alignItems(AlignItems.Center),
            verticalAlignment = Alignment.CenterVertically
        ) {
            currentSelectedCoaches.forEach { coach ->
                Row(
                    modifier = Modifier
                        .gap(4.px)
                        .height(28.px)
                        .backgroundColor(tokenBackgroundColor ?: sitePalette.modalBackgroundColor.rgb)
                        .borderRadius(4.px)
                        .padding(6.px),
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.SpaceBetween
                ) {
                    FieldTitleTextNormalSimple(
                        "${coach.firstName} ${coach.lastName}",
                        fontSize = 12.px,
                    )
                    Image(
                        src = Res.Images.cross_Icon,
                        modifier = Modifier.onClick {
                            scope.launch {
                                onCoachRemoved(sentenceId, coach)
                                if (apiHit) {
                                    tagUser(
                                        sessionID = sessionId,
                                        userID = coach.userId,
                                        sentenceID = sentenceId,
                                        isRemove = true,
                                        organization = AppGlobal.userData.organization

                                    )
                                }
                            }
                        }.cursor(Cursor.Pointer)
                    )
                }
            }

            Input(
                type = InputType.Text,
                attrs = Modifier
                    .width(if (currentSelectedCoaches.isEmpty())  100.percent else 100.px)
                    .height(32.px)
                    .color(sitePalette.textFieldTextColor.rgb)
                    .backgroundColor(Colors.Transparent)
                    .noBorder()
                    .fontFamily(Constants.IBM_FONT)
                    .fontSize(13.px)
                    .classNames("dropdown-trigger")
                    .onBlur { isFocused = false }
                    .onFocusIn { it ->
                        showDropdown = true
                        isFocused = true
                        filteredCoaches = coaches.filter {
                            it.userId != currentCoachId &&
                                    currentSelectedCoaches.none { selected -> selected.userId == it.userId }
                        }
                        it.stopPropagation()
                    }
                    .onKeyUp {
                        val searchText = (document.getElementById(searchInputId) as HTMLInputElement).value
                        filteredCoaches = if (searchText.isNotEmpty()) {
                            coaches.filter { coach ->
                                val fullName = "${coach.firstName} ${coach.lastName}".lowercase()
                                val search = searchText.lowercase()
                                fullName.contains(search) &&
                                        currentSelectedCoaches.none { it.userId == coach.userId } &&
                                        coach.userId != currentCoachId
                            }
                        } else {
                            coaches.filter {
                                it.userId != currentCoachId &&
                                        currentSelectedCoaches.none { selected -> selected.userId == it.userId }
                            }
                        }
                        showDropdown = searchText.isNotEmpty()
                    }
                    .toAttrs {
                        id(searchInputId)
                        attr(
                            "placeholder",
                            if (currentSelectedCoaches.isEmpty()) "Search coaches..." else ""
                        )
                    }
            )
        }

        if (showDropdown && filteredCoaches.isNotEmpty()) {
            Box(
                modifier = Modifier
                    .fillMaxWidth()
                    .backgroundColor(sitePalette.modalBackgroundColor.rgb)
                    .borderRadius(8.px)
                    .border(1.px, style = LineStyle.Solid, color = sitePalette.coachDetailsBoxBorder.rgb)
                    .position(Position.Absolute)
                    .run {
                        if (openUpward) {
                            bottom(50.px)
                        } else {
                            top(50.px)
                        }
                    }
                    .zIndex(10)
                    .maxHeight(200.px)
                    .overflow(Overflow.Auto)
            ) {
                Column {
                    filteredCoaches.forEach { coach ->
                        Box(
                            modifier = Modifier
                                .fillMaxWidth()
                                .padding(8.px)
                                .onClick {
                                    scope.launch {
                                        val alreadyTagged = currentSelectedCoaches.any { it.userId == coach.userId }
                                        if (!alreadyTagged) {
                                            onCoachSelected(sentenceId, coach)
                                            if (apiHit) {
                                                tagUser(
                                                    sessionID = sessionId,
                                                    userID = coach.userId,
                                                    sentenceID = sentenceId,
                                                    isRemove = false,
                                                    organization = AppGlobal.userData.organization
                                                )
                                            }
                                        }
                                        (document.getElementById(searchInputId) as HTMLInputElement).value = ""
                                        showDropdown = false
                                    }
                                }
                                .cursor(Cursor.Pointer)
                        ) {
                            FieldTitleTextNormalSimple(
                                "${coach.firstName} ${coach.lastName}",
                                fontSize = 13.px
                            )
                        }
                    }
                }
            }
        }
    }
}
